var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34.057,
    viewBox: "0 0 33 34.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key-outline",
    transform: "translate(1 1)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M30.916,27.428a9,9,0,0,0,.306,2.884c-3.212,3.9-11.692,14.21-12.482,15a1.58,1.58,0,0,0-.5,1.157,2.613,2.613,0,0,0,.715,1.642c.492.532,2.593,2.544,2.981,2.159,1.148-1.157,1.379-1.465,1.848-1.943.708-.717-.075-2.182.171-2.776a1.1,1.1,0,0,1,.931-.8,13.483,13.483,0,0,1,1.766.231,1.841,1.841,0,0,0,1.416-.709,1.637,1.637,0,0,0,.648-1.2c.015-.694-.954-1.611-.231-2.344s1.766.478,2.534.386a2.852,2.852,0,0,0,1.8-1.665c.1-.47-.872-1.681-.723-2.367a1.581,1.581,0,0,1,.85-.848c.343-.077,1.863.532,2.206.455a5.206,5.206,0,0,0,1.3-.8A8.15,8.15,0,0,0,40,36.6,9.182,9.182,0,1,0,40,18.24,9.082,9.082,0,0,0,30.916,27.428Zm13.555-1.786a2.386,2.386,0,1,1-2.385-2.467A2.427,2.427,0,0,1,44.471,25.642Z",
    transform: "translate(-18.24 -18.24)",
    fill: "none",
    stroke: "#4f9a9a",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyOutline);
export default __webpack_public_path__ + "static/media/key-outline.36babebf6bf0c0da945d08184b0f825e.svg";
export { ForwardRef as ReactComponent };